export default {
  "content": "<g clip-path=\"url(#a)\"><path d=\"M13.227 1.91h-1.56V.863a.112.112 0 00-.114-.113H10.44c-.06 0-.106.047-.106.113V1.91H4.327V.897c0-.08-.047-.147-.114-.147H3.1c-.06 0-.107.067-.107.147V1.91H.773a.44.44 0 00-.44.44v1.76h13.334V2.35a.44.44 0 00-.44-.44z\" fill=\"#3F4450\"/></g><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M.333 5.416v8.893c0 .24.2.44.44.44h12.454c.24 0 .44-.2.44-.44V5.416H.333zm1.917 1.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2z\" fill=\"#3F4450\"/><defs><clipPath id=\"a\"><path fill=\"#fff\" transform=\"translate(.333 .75)\" d=\"M0 0h13.333v14H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "14",
    "height": "15",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};